import React from 'react';
import Slider from 'react-slick';
import { Box, Typography, Grid } from '@mui/material';
import {
  Phone as PhoneIcon,
  Email as EmailIcon
} from '@mui/icons-material';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { SiMedium } from "react-icons/si";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LanguageIcon from '@mui/icons-material/Language';
import YouTubeIcon from '@mui/icons-material/YouTube';

const SocialIcon = ({ platform, url, color, Icon }) => {
  const gradients = {
    phone: '#000',
    email: '#000',
    facebook: 'linear-gradient(45deg, #1877F2, #166FE5)',
    instagram: 'linear-gradient(45deg, #833AB4, #FD1D1D, #FCAF45)',
    twitter: 'linear-gradient(45deg, #1DA1F2, #0E71C8)',
    linkedin: 'linear-gradient(45deg, #0077B5, #00669C)',
    medium: 'linear-gradient(45deg, #000, #333)',
    website: 'linear-gradient(45deg, #000, #333)',
    youtube: 'linear-gradient(45deg, #FF0000, #CC0000)'
  };

  const handleClick = (e) => {
    e.preventDefault();
    if (platform === 'phone') {
      window.location.href = `tel:${url}`;
    } else if (platform === 'email') {
      window.location.href = `mailto:${url}`;
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <Box
      component="a"
      onClick={handleClick}
      sx={{
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '3.75rem',
        height: '3.75rem',
        padding: '0',
        margin: '0',
        borderRadius: '1rem',
        backgroundColor: '#fff',
        background: gradients[platform],
        color: '#fff',
        '&:hover': {
          opacity: 0.9,
          transform: 'scale(1.05)',
          transition: 'all 0.2s ease-in-out'
        },
        cursor: 'pointer'
      }}
    >
      <Icon style={{ fontSize: '2.2rem' }} />
    </Box>
  );
};

const SocialIcons = ({ social_links }) => {
  const socialPlatforms = [
    { key: 'phone', color: '#fff', Icon: PhoneIcon },
    { key: 'email', color: '#fff', Icon: EmailIcon },
    { key: 'website', color: '#000', Icon: LanguageIcon },
    { key: 'facebook', color: '#1877F2', Icon: FacebookRoundedIcon },
    { key: 'instagram', color: '#E1306C', Icon: InstagramIcon },
    { key: 'twitter', color: '#1DA1F2', Icon: TwitterIcon },
    { key: 'linkedin', color: '#0077B5', Icon: LinkedInIcon },
    { key: 'medium', color: '#000', Icon: (props) => <SiMedium style={{ fontSize: '2.2rem' }} {...props} /> },
    { key: 'youtube', color: '#FF0000', Icon: YouTubeIcon },

  ];

  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: false,
    rtl: false,
    centerMode: false,
    variableWidth: true
  };

  // Helper to check if a URL contains a username (alphanumeric after last '/')
  const hasUsername = (url) => {
    if (!url || typeof url !== 'string') return false;
    try {
      const u = new URL(url);
      const path = u.pathname.replace(/\/+$/, ''); // remove trailing slash
      const username = path.split('/').pop();
      return !!username && /^[a-zA-Z0-9._-]+$/.test(username);
    } catch {
      return false;
    }
  };

  return (
    <Grid item xs={12} textAlign="left" p="20px"
      sx={{
        borderRadius: '12px',
        backgroundColor: '#1E1E1E',
        padding: '1.5rem',
        color: '#ffffff'
      }}>
      <Typography variant="h6" sx={{
        marginBottom: '1rem',
        fontWeight: 'semibold',
      }}>
        Contact
      </Typography>

      <Box sx={{
        '&::-webkit-scrollbar': {
          display: 'none'
        },
        '.slick-slide': {
          width: '72px !important'
        },
        '.slick-list': {
          display: 'flex',
          justifyContent: 'flex-start',
        },
        '.slick-track': {
          display: 'flex',
          alignItems: 'flex-start',
          margin: '0',
        },
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        textAlign: "left"
      }}>
        <Slider {...sliderSettings}>{socialPlatforms?.map(platform => {
          const url = social_links?.[platform.key];
          const shouldShow = platform.key === 'phone' || platform.key === 'email'
            ? Boolean(url)
            : url?.startsWith('http');
          if (shouldShow) {
            return (
              <SocialIcon
                key={platform.key}
                platform={platform.key}
                url={url}
                color={platform.color}
                Icon={platform.Icon}
              />
            );
          }
          return null;
        })}
        </Slider>
      </Box>
    </Grid>
  );
};

export default SocialIcons;
